import { BasePostProvider } from "@tendercuts/http";
import { EndPoint } from "./base";
import { Injectable } from "@angular/core";
import { LoginServices } from "./login";
import { HttpClient, HttpParams } from "@angular/common/http";
import { PosUser } from '../models';

@Injectable({ providedIn: "root" })
export class SearchPosCustomer extends BasePostProvider<PosUser> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return PosUser;
  }

  get endpoint() {
    return this.endpointService.searchPosCustomer;
  }
}
